// The "period" filter is a year offset from the current year:
//   0 = next year, 1 = current year, 2 = last year, 3 = the year before, ...
// i.e. year = currentYear - (period - 1). The server uses the same rule.

// The oldest year offered when the building has no registration year set. Normally the list starts at
// the building's registration year. It always runs from the current year back to that year, so it grows
// by one entry every 1 January and no year ever drops off the end.
export const FIRST_YEAR = 2024

// Future years offered in addition to the current year (0 = none). With 1, "Next year" is also listed.
export const YEARS_AHEAD = 0

const toNumber = period => (period === null || period === undefined || period === '' ? NaN : Number(period))

// A missing or invalid period means the current year
export function periodOffset (period) {
  const n = toNumber(period)
  return Number.isFinite(n) ? n - 1 : 0
}

export function isCurrentPeriod (period) {
  return periodOffset(period) === 0
}

export function yearsBack (period) {
  return periodOffset(period)
}

export function periodYear (period, now = new Date()) {
  return now.getFullYear() - periodOffset(period)
}

// firstYear: the building's registration year. Newest first, e.g. in 2027 with firstYear 2024: [{ value: 1, label: 'Current year (2027)' }, { value: 2, label: 'Last year (2026)' },
// { value: 3, label: '2025' }, { value: 4, label: '2024' }]
export function periodOptions (now = new Date(), firstYear = FIRST_YEAR) {
  const start = Number(firstYear) > 0 ? Number(firstYear) : FIRST_YEAR
  const current = now.getFullYear()
  const options = []
  for (let ahead = YEARS_AHEAD; ahead >= 1; ahead--) {
    options.push({ value: 1 - ahead, label: (ahead === 1 ? 'Next year' : 'In ' + ahead + ' years') + ' (' + (current + ahead) + ')' })
  }
  for (let year = current; year >= Math.min(start, current); year--) {
    const back = current - year
    const label = back === 0 ? 'Current year (' + year + ')' : back === 1 ? 'Last year (' + year + ')' : String(year)
    options.push({ value: 1 + back, label })
  }
  return options
}
